import {Container} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {requireAdminBeforeLoad} from '../../../auth/require-admin-before-load'
import {SettingsPage} from '../../../settings/settings-page'

export const Route = createFileRoute('/_app/settings/')({
    beforeLoad: requireAdminBeforeLoad,
    component: SettingsRoute,
})

function SettingsRoute() {
    return (
        <Container size="md" py="xl">
            <SettingsPage />
        </Container>
    )
}
